import { useQuery } from '@tanstack/react-query';
import { myProfileApi } from '../api/myProfileApi';
import type { MyProfileResponse } from '../types/myProfile';

/**
 * GET /api/eraf/me — 내 프로필 조회
 * queryKey: ['my-profile'] — ['auth','me'] 와 분리
 */
export function useMyProfile() {
  return useQuery<MyProfileResponse>({
    queryKey: ['my-profile'],
    queryFn: () => myProfileApi.get(),
    staleTime: 60_000,
    retry: false,
  });
}
